import { z } from "zod";

export const aiArtifactSavedToolOutputSchema = z.object({
  id: z.string().min(1),
  organizationId: z.string().min(1),
  title: z.string().min(1),
  revision: z.string().min(1),
  shared: z.boolean(),
  sourceChatID: z.string().nullable().optional(),
});

export type AiArtifactSavedToolOutput = z.infer<
  typeof aiArtifactSavedToolOutputSchema
>;

export function parseAiArtifactSavedToolOutput(
  output: unknown,
): AiArtifactSavedToolOutput | null {
  if (typeof output !== "object" || output === null) {
    return null;
  }
  const result = aiArtifactSavedToolOutputSchema.safeParse(output);
  return result.success ? result.data : null;
}

/** Resolve detail and preview paths from trusted workspace/id, never model URLs. */
export function buildArtifactDetailPath(
  locale: string,
  organizationId: string,
  artifactId: string,
): string {
  return `/${locale}/${encodeURIComponent(organizationId)}/artifacts/${encodeURIComponent(artifactId)}`;
}

export function buildArtifactPreviewPath(
  organizationId: string,
  artifactId: string,
  locale: string,
  theme?: "light" | "dark",
): string {
  const params = new URLSearchParams({ lang: locale });
  if (theme === "light" || theme === "dark") {
    params.set("theme", theme);
  }
  return `/api/artifacts/${encodeURIComponent(organizationId)}/${encodeURIComponent(artifactId)}/preview?${params.toString()}`;
}
